import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import SkeltonScreens from '../../Utils/skeltonScreens.js';
import Network from '../../Utils/network.js';
import GeneralUtils from '../../Utils/generalUtils.js';
import { FaCreditCard, FaArrowRight } from 'react-icons/fa';
import { Modal, ModalBody, Button } from 'reactstrap';
import SliderModal from '../../Utils/sliderModal.js';
import Swal from 'sweetalert2';
import NoDataFound from '../../Utils/noDataFound.js';
import Constants from '../../Utils/constants.json';

class PaymentComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            profileId: "NA",
            isPaymentModalVisible: false,
            manifest: "",
            deviceId: "",
            isCreditDebitCardChecked: false,
            isPaypalChecked: false,
            isDwollaChecked: false,
            isAddCardBtnEnabled: false,
            dwollaCustomerUrl: "",
            dwollaIavToken: "",
            tsysReferenceId: "",
            finalOrderId: "",
            isAutopayEnabled: false,
            paypalClientId: "",
            paypalAmount: "",
            paypalAccessToken: "",
            accountId: "",
            firstName: "",
            lastName: "",
            emailId: "",
            phoneNumber: "",
            paymentFor: "",
            paymentAmount: "",
            finalPaymentAmount: "",
            CCDCPaymentMethodAllowed: false,
            payaplPaymentMethodAllowed: true,
            dwollaPaymentMethodAllowed: false,
            billStartDate: "",
            billEndDate: "",
            billPeriod: "",
            billDueDate: "",
            expiryDate: "",
            paymentReceipt: "",
            ransactionId: "",
            token: "",
            fundingSource: "",
            isSaveCardRequired: false,
            savedCardDetails: [],
            payfromNewCard: false,
            payfromSavedCard: false,
            dwollaFundingSourceId: "",
            dwollaFundingSourceName: "",
            isDwollaCustomerExisting: false,
            dwollaEmailAddress: "",
            dwollaFirstName: "",
            dwollaLastName: "",
            isOtpBtnClicked: false,
            isDwollaLoggedIn: false,
            dwollaOtp: "",
            fundingSourcesArray: [],
            isDwollaVerifiedFSExisting: false,
            isDwollaTandCClicked: false,
            isDwollaTandCModalOpen: false,
            isAccountCreated: false,
            showDwollaTermsAndConditions: false,
            changePaymentMethodClicked: false,
            isSavedCardSelected: false,
            diffAmount: 0,
            cardType: "",
            isPaypalButtonRendered: false
        }
    }

    generateReceiptNumber = () => {
        var number = Math.floor(100000 + Math.random() * 900000);
        number = "SCM" + number;
        return number;
    }

    changePaymentMethodTo(type) {
        if (type === "savedCards") {
            this.setState({
                changePaymentMethodClicked: true
            })
        } else if (type === "allMethods") {
            this.setState({
                changePaymentMethodClicked: false
            })
        }
    }

    accountCreationTandCLinkClicked = () => {
        this.setState({
            isDwollaTandCModalOpen: true
        })
    }

    accountCreationTandCCloseBtnClicked = () => {
        this.setState({
            isDwollaTandCModalOpen: false
        })
    }

    addFSTandCDeclineBtnClicked = () => {
        this.setState({
            showDwollaTermsAndConditions: false
        })
    }

    addFSTandCAcceptBtnClicked = () => {
        document.getElementById("dwollaIframe").contentWindow.startDwollaFlow();
        this.setState({
            showDwollaTermsAndConditions: false
        })
    }

    dwollaProceedBtnClicked = () => {
        this.setState({ isLoading: true })
        var dataToSend = {
            firstName: this.state.dwollaFirstName,
            lastName: this.state.dwollaLastName,
            email: this.state.dwollaEmailAddress
        }
        Network.executeAxios("dwollaCreateUnverifiedCustomer", "POST", dataToSend, (customerUrl) => {
            if (customerUrl.STATUS === "SUCCESS") {
                var dataToSend = {
                    customerUrl: customerUrl.URL
                }
                Network.executeAxios("dwollaGetIavToken", "POST", dataToSend, (iavToken) => {
                    this.state.dwollaIavToken = iavToken;
                    this.setState({
                        isAccountCreated: true,
                        isLoading: false
                    })
                });
            } else {
                Swal.fire("Creating Customer failed", "", "");
                this.setState({
                    isLoading: false
                })
            }
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('message', this.processMessage);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.removeEventListener('resize', this.updateWindowDimensions);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('message', this.processMessage);

        window.addEventListener('resize', this.updateWindowDimensions);
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('message', this.processMessage, false);

        var finalAmount = "0.00"
        if(parseFloat(this.props.amount) > 0) finalAmount = this.props.amount;
        var finalPaymentAmountFromProps = parseFloat((finalAmount.replace(',','')))

        this.setState({
            isLoading: true,
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            billId: this.props.billId,
            paymentAmount: finalAmount,
            finalPaymentAmount: finalPaymentAmountFromProps,
            accountId: this.props.accountId,
            billStartDate: this.props.billStartDate,
            billEndDate: this.props.billEndDate,
            billPeriod: this.props.billPeriod,
            phoneNumber: this.props.phoneNumber,
            emailId: this.props.emailId,
            billDueDate: this.props.billDueDate,
            profileId: this.props.profileId,
            dwollaEmailAddress: this.props.emailId,
            dwollaFirstName: this.props.firstName,
            dwollaLastName: this.props.lastName
        })

        Network.executeAxios("FetchChannelPaymentMethods", "GET", "", (channelPaymentMethodsResponse) => {
            this.manageChannelPaymentMethods(channelPaymentMethodsResponse);
            Network.executeAxios("fetchSavedCardDetails", "POST", "", (saveCardResponse) => {
                this.initializeSavedCardsForCCDC(saveCardResponse);
                //  Network.executeAxios("getManifest", "POST","", (manifestResponse) => { 
                //     this.handleManifestResponse(manifestResponse);
                var receivedAmount = parseFloat((this.state.paymentAmount.replace(',', '')))
                if (parseFloat(this.state.finalPaymentAmount) > (parseFloat(receivedAmount))) {
                    var diffAmount = parseFloat(this.state.finalPaymentAmount) - parseFloat(receivedAmount)
                }

                Network.executeAxios("getPaypalClientId", "GET", "", (response) => {
                    this.setState({
                        paypalClientId: response.CLIENT_ID,
                        paypalAmount: GeneralUtils.formatNumberToStandardForm(this.state.finalPaymentAmount,this.props.configurationValues),
                        isPaymentModalVisible: true,
                        isLoading: false,
                        diffAmount: diffAmount
                    })
                });
                //});
            });
        });


    }

    processMessage = (event) => {
        if (event.data.showDwollaTermsAndConditions) {
            this.setState({ showDwollaTermsAndConditions: true })
        }
        if (event.data.isAddFundingSourceClicked) {
            this.setState({ addFSClicked: true })
        }
        if (event.data.isPaypalButtonRendered) {
            setTimeout(() => {
                this.setState({ isPaypalButtonRendered: true })
            }, 1500);
        } else {
            this.setState({ isPaypalButtonRendered: false })
        }

        if (event.data.responseCode && event.data.responseCode != "") {
            //var self=this;    casting (now we can call functions like self.function())
            if (event.data.status === "PASS") {
                var expiryDate = event.data.expirationDate;
                var cvv = event.data.cvv2;
                var cvvValue = cvv.trim();
                expiryDate = expiryDate.replace('/', '');
                this.setState({
                    isAddCardBtnEnabled: true
                })
                this.setState({
                    amount: GeneralUtils.formatNumberToStandardForm(this.state.finalPaymentAmount,this.props.configurationValues),
                    tsysToken: event.data.tsepToken,
                    expiryDate: expiryDate,
                    cvv: cvvValue,
                    lastFourDigit: event.data.maskedCardNumber
                })
            } else {
                Swal.fire("Invalid Card", "", "");
            }
        } else if (event.data.type && event.data.type === "dwolla") {
            this.setState({
                isLoading: true
            })
            var dataToSend = {
                email: this.state.dwollaEmailAddress
            }
            Network.executeAxios("dwollaExistingCustomerCheck", "POST", dataToSend, (dwollaResponse) => {
                this.handleDwollaExistingCustomer(dwollaResponse)
            });


            // this.setState({
            //     isLoading : true
            // })     
            // var response = JSON.parse(event.data.res);
            // var linksObject = response._links;
            // linksObject['fundingSource'] = linksObject['funding-source'];
            // var fundingSource = linksObject.fundingSource.href;
            // var dataToSend = {
            //     emailID : this.state.emailId,
            //     fundingSourceUrl : fundingSource,
            //     amount : GeneralUtils.formatNumberToStandardForm(this.state.finalPaymentAmount)
            // }
            // if(parseInt(this.state.finalPaymentAmount) > 0 ) {
            //     Network.executeAxios("dwollaMakeTransfer", "POST",dataToSend, (transferResponse) => { 
            //         if(transferResponse != null && transferResponse != undefined && transferResponse != ""){
            //             this.state.transactionId=transferResponse;
            //             this.state.fundingSource=fundingSource;
            //             this.handlePostTransactionOfChannels("8","DWOLLA");  
            //         }  else {
            //             Swal.fire("","Payment Failed","error");
            //         }
            //     });
            // } else {
            //     Swal.fire("","Your Current due is $0","warning");
            //     this.setState({ isLoading : false });
            // }

        } else if (event.data.type && event.data.type === "paypal") {
            this.setState({
                isLoading: true
            })
            var receiptNumber = this.generateReceiptNumber();
            var response = event.data.details;
            if (response.status === "COMPLETED") {   // success case
                this.state.transactionId = response.purchase_units[0].payments.captures[0].id;   //transaction or capture id
                this.handlePostTransactionOfChannels("9", "PAYPAL", receiptNumber);
            } else {
                this.paymentFailedProcess("PAYPAL", receiptNumber)
            }
        } else {
            console.log("message => ", event.data);
        }

    }

    populateFundingSources() {
        const allFundingSources = this.state.fundingSourcesArray.map((item, key) => {
            if (item.id === this.state.dwollaFundingSourceId) {
                return (
                    <div>
                        {item.status === "verified" ?
                            <div className="py-2" key={key} style={{ borderBottom: '1px solid #d6d6d6' }}>
                                <div className="custom-control custom-radio custom-control-inline" style={{ cursor: 'pointer' }} >
                                    <input type="radio" id={"fundingSource" + key} name="fundingSource" className="custom-control-input" checked onChange={(event) => this.manageFundingSourceRadio(key, item.id)} />
                                    <label className="custom-control-label" htmlFor={"fundingSource" + key} style={{ cursor: 'pointer', fontSize: 16, fontWeight: 500 }}>{item.name}</label>
                                </div>
                            </div>
                            :
                            null
                        }
                    </div>
                )
            } else {
                return (
                    <div>
                        {item.status === "verified" ?
                            <div className="py-2" key={key} style={{ borderBottom: '1px solid #d6d6d6' }}>
                                <div className="custom-control custom-radio custom-control-inline" style={{ cursor: 'pointer' }} >
                                    <input type="radio" id={"fundingSource" + key} name="fundingSource" className="custom-control-input" onChange={(event) => this.manageFundingSourceRadio(key, item.id)} />
                                    <label className="custom-control-label" htmlFor={"fundingSource" + key} style={{ cursor: 'pointer', fontSize: 16, fontWeight: 500 }}>{item.name}</label>
                                </div>
                            </div>
                            :
                            null
                        }
                    </div>
                )
            }
        });
        if (this.state.fundingSourcesArray.length > 0) {
            return (allFundingSources)
        } else {
            return (<div class="noFundingSourceLabel text-center m-0" style={{ borderTop: 0 }}>No Funding Source Available</div>)
        }
    }

    handleInputValueChangeForText(name, value) {
        this.state[name] = value;
        this.setState({ dummy: "dummy" });
    };

    handleDwollaExistingCustomer = (dwollaResponse) => {
        var totalCount = 0;
        var customerId = ""
        if (dwollaResponse && dwollaResponse.total) {
            totalCount = dwollaResponse.total;
        }
        if (totalCount > 0 && dwollaResponse._embedded.customers[0].status != "deactivated") {
            customerId = dwollaResponse._embedded.customers[0].id;
            this.setState({ dwollaCustomerId: customerId })
            var dataToSend = {
                customerId: customerId
            }
            Network.executeAxios("dwollaGetFundingSource", "POST", dataToSend, (getFundingSourceRes) => {
                var fundingSourceId = "";
                var fundingSourceName = "";
                if (getFundingSourceRes && getFundingSourceRes._embedded) {
                    var embeddedObject = getFundingSourceRes._embedded;
                    embeddedObject['fundingSource'] = embeddedObject['funding-sources'];
                    if (embeddedObject.fundingSource.length > 0) {
                        this.setState({
                            fundingSourcesArray: embeddedObject.fundingSource
                        })
                        if (embeddedObject.fundingSource[0].status === "verified") {
                            fundingSourceId = embeddedObject.fundingSource[0].id;
                            fundingSourceName = embeddedObject.fundingSource[0].name;
                            this.state.dwollaFundingSourceId = fundingSourceId;
                            this.state.dwollaFundingSourceName = fundingSourceName;
                            var customerUrlToSend = {
                                customerUrl: 'https://api-sandbox.dwolla.com/customers/' + customerId
                            }
                            Network.executeAxios("dwollaGetIavToken", "POST", customerUrlToSend, (iavToken) => {
                                this.state.dwollaIavToken = iavToken;
                                this.setState({
                                    isDwollaCustomerExisting: true,
                                    isDwollaVerifiedFSExisting: true,
                                    isDwollaLoggedIn: true,
                                    addFSClicked: false,
                                    isLoading: false,
                                    isCreditDebitCardChecked: false,
                                    isDwollaChecked: true,
                                    isPaypalChecked: false,
                                    isAccountCreated: true
                                })
                            });

                        } else {
                            Swal.fire("Funding source is unverified", "", "");
                            this.setState({
                                isOtpBtnClicked: false,
                                isDwollaLoggedIn: false,
                                isLoading: false
                            })
                        }

                    } else {
                        // Swal.fire("","No Funding source for this existing user","warning");
                        // this.setState({
                        //     isOtpBtnClicked : false,
                        //     isDwollaLoggedIn : false,
                        //     isLoading : false
                        // })

                        var customerUrlToSendInApi = {
                            customerUrl: 'https://api-sandbox.dwolla.com/customers/' + customerId
                        }
                        Network.executeAxios("dwollaGetIavToken", "POST", customerUrlToSendInApi, (iavToken) => {
                            this.state.dwollaIavToken = iavToken;
                            this.setState({
                                isDwollaCustomerExisting: true,
                                isDwollaVerifiedFSExisting: true,
                                isDwollaLoggedIn: true,
                                addFSClicked: false,
                                isLoading: false,
                                isCreditDebitCardChecked: false,
                                isDwollaChecked: true,
                                isPaypalChecked: false,
                                isAccountCreated: true
                            })
                        });
                    }
                }

            });
        } else {
            this.setState({
                isLoading: false,
                isCreditDebitCardChecked: false,
                isDwollaChecked: true,
                isPaypalChecked: false
            })
            // var dataToSend = {
            //     firstName: this.state.firstName,
            //     lastName: this.state.lastName,
            //     email: this.state.dwollaEmailAddress
            // }
            // Network.executeAxios("dwollaCreateUnverifiedCustomer", "POST",dataToSend, (customerUrl) => { 
            //     if(customerUrl.STATUS  === "SUCCESS") {
            //         var dataToSend = {
            //             customerUrl : customerUrl.URL
            //         }
            //         Network.executeAxios("dwollaGetIavToken", "POST",dataToSend, (iavToken) => { 
            //             this.state.dwollaIavToken = iavToken;
            //             this.setState({
            //                 isDwollaCustomerExisting : false,
            //                 isDwollaLoggedIn : true,
            //                 isLoading : false
            //             })                       
            //         });
            //     } else {
            //         Swal.fire("","Creating Customer failed","warning");
            //         this.setState({
            //             isDwollaLoggedIn : false,
            //             isLoading : false
            //         }) 
            //     }
            // });
        }

    }

    manageFundingSourceRadio(key, FundingSourceId) {
        this.setState({
            dwollaFundingSourceId: FundingSourceId
        })
    };

    getOtpBtnClicked = () => {
        //send otp to the this.state.dwollaEmailAddress
        this.setState({ isLoading: true });

        setTimeout(() => {
            this.setState({
                isLoading: false,
                isOtpBtnClicked: true
            })
        }, 1000);
    }


    // verifyOtpBtnClicked = () => {
    //     this.setState({ isLoading : true });
    //     if(this.state.dwollaOtp  === "1234") {

    //     }
    // }

 
    initializeSavedCardsForCCDC(receivedResponse) {
        var autoPaymentDetails = [];
        try {

            autoPaymentDetails = receivedResponse.BillingSystem.response.dataset.autoPaymentDetails;
        } catch (e) {
            autoPaymentDetails = [];
        }
        this.setState({
            savedCardDetails: autoPaymentDetails
        })

    }
    manageChannelPaymentMethods(channelPaymentMethodsResponse) {
        try {
            if (channelPaymentMethodsResponse && channelPaymentMethodsResponse.BillingSystem && channelPaymentMethodsResponse.BillingSystem.result_code && channelPaymentMethodsResponse.BillingSystem.result_code == "0") {

                var channelPaymethodAllowedArray = channelPaymentMethodsResponse.BillingSystem.response.dataset.channel_payment_info;
                for (var i = 0; i < channelPaymethodAllowedArray.length; i++) {
                    if (channelPaymethodAllowedArray[i].payment_method_id == "1") {
                        this.state.CCDCPaymentMethodAllowed = true;
                    }
                    if (channelPaymethodAllowedArray[i].payment_method_id == "9") {
                        this.state.payaplPaymentMethodAllowed = true;
                    }
                    if (channelPaymethodAllowedArray[i].payment_method_id == "8") {
                        this.state.dwollaPaymentMethodAllowed = true;
                    }
                }
            }
        } catch (e) {
            console.log("exception", e);
            this.state.CCDCPaymentMethodAllowed = true;
        }

    }
    handleManifestResponse(manifestResponse) {
        var deviceIdToSend = manifestResponse.deviceId;
        manifestResponse = manifestResponse.response;
        var manifestValue = "";
        try {
            if (manifestResponse.entityorAttribute && manifestResponse.entityorAttribute.characteristic) {
                manifestValue = manifestResponse.entityorAttribute.characteristic[0].value;
            }
        } catch (err) {
            manifestValue = "";
        }

        this.setState({
            manifest: manifestValue,
            deviceId: deviceIdToSend
        })
    }


    updateWindowDimensions = () => {
        console.log("updating window diamentions")
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    paymentModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            this.setState({ isPaymentModalVisible: false, isAddCardBtnEnabled: false })
            this.props.callbackFromParent(false);
        }
    }

    handleInputValueCheckBox(name, event) {
        const value = event.target.checked;
        this.setState({ [name]: value })
    };

    handleInputValueChange(name, value) {
        const validated = value.match(/^(\d*\.{0,1}\d{0,2}$)/)
        if(validated){
            this.state.finalPaymentAmount = value
            this.state.paypalAmount = value
            var receivedAmount = parseFloat((this.state.paymentAmount.replace(',','')))
            if(parseFloat(this.state.finalPaymentAmount) > (parseFloat(receivedAmount))){
                var diffAmount = parseFloat(this.state.finalPaymentAmount) - parseFloat(receivedAmount)
            } 
                  
            this.setState({
                diffAmount: diffAmount
            });
        }
    }

    handleInputValueChangeForPaymentMethods(name, value) {
        if (name === "paymentMethodSelectionRadio" && value === "creditDebitCard") {
            this.setState({
                isLoading: true
            })
            Network.executeAxios("getManifest", "POST", "", (manifestResponse) => {
                this.handleManifestResponse(manifestResponse);
                this.setState({
                    isCreditDebitCardChecked: true,
                    isDwollaChecked: false,
                    isPaypalChecked: false,
                    isLoading: false
                })
            });
        } else if (name === "paymentMethodSelectionRadio" && value === "paypalPayment") {
            this.setState({
                isCreditDebitCardChecked: false,
                isDwollaChecked: false,
                isPaypalChecked: true
            })
        } else if (name === "paymentMethodSelectionRadio" && value === "dwollaPayment") {
            this.setState({
                isLoading: true
            })
            var dataToSend = {
                email: this.state.dwollaEmailAddress
            }
            Network.executeAxios("dwollaExistingCustomerCheck", "POST", dataToSend, (dwollaResponse) => {
                this.handleDwollaExistingCustomer(dwollaResponse)
            });

        }
        this.setState({ dummy: "dummy" });
    };

    addPaymentMethodClicked = () => {
        this.setState(prevState => {
            return {
                payfromNewCard: !prevState.payfromNewCard,
            };
        });
    }

    // santosh
    paymentCancelBtnClicked = () => {
        this.setState({
            isCreditDebitCardChecked: false,
            isAddCardBtnEnabled: false,
            payfromNewCard: false

        })
    }
    paymentCancelBtnSavedCard = () => {
        this.setState({

        })
    }

    payNowBtnClicked = () => {
        this.setState({ isLoading: true });
        var dataToSend = {
            amount: this.state.amount,
            token: this.state.tsysToken,
            expiryDate: this.state.expiryDate,
            cvv: this.state.cvv,
            lastFourDigit: this.state.lastFourDigit
        }
        Network.executeAxios("makePaymentViaTsys", "POST", dataToSend, (TsysResponse) => {
            this.handleTsysPaymentResponse(TsysResponse);
        });
    }

    handleTsysPaymentResponse = (TsysResponse) => {
        var receiptNumber = this.generateReceiptNumber();
        try {
            if (TsysResponse.responseAttribute && TsysResponse.responseAttribute.responseCode === "200" && TsysResponse.payment && TsysResponse.payment.paymentMethod && TsysResponse.payment.paymentMethod.status === "A0000") {
                if (TsysResponse.payment && TsysResponse.payment.paymentMethod && TsysResponse.payment.paymentMethod.customerReciept) {
                    this.state.paymentReceipt = TsysResponse.payment.paymentMethod.customerReciept
                    this.state.transactionId = TsysResponse.payment.paymentMethod.transactionId
                    this.state.token = TsysResponse.payment.paymentMethod.token
                    this.state.tsysReferenceId = TsysResponse.responseAttribute.referenceNo
                    this.state.cardType = TsysResponse.payment.paymentMethod.cardType
                    this.handlePostTransactionOfChannels("1", "TSYS", receiptNumber)
                }
            } else {
                this.paymentFailedProcess("TSYS", receiptNumber)
                this.setState({
                    isAddCardBtnEnabled: false,
                    isLoading: false
                })
            }
        } catch (err) {
            this.state.paymentReceipt = "";
        }

    }

    paymentFailedProcess(paymentTypeName, receiptNumber) {
        var dataToSend = {
            profileId: this.state.profileId,
            accountId: this.state.accountId,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailID: this.state.emailId,
            phoneNumber: this.state.phoneNumber,
            amount: GeneralUtils.formatNumberToStandardForm(this.state.finalPaymentAmount,this.props.configurationValues),
            transactionId: "",
            token: this.state.token,
            paymentType: paymentTypeName,
            fundingSource: this.state.fundingSource,
            cardExpiryDate: this.state.expiryDate,
            receiptNumber: receiptNumber,
            cardType: this.state.cardType
        }
        Network.executeAxios("insertPaymentDetails", "POST", dataToSend, (Response) => {
            if (Response.STATUS === "SUCCESS") {
                Swal.fire("Payment Failed", "", "")
            }
        });
    }

    handlePostTransactionOfChannels(paymentTypeId, paymentTypeName, receiptNumber) {

        var dataToSend = {
            profileId: this.state.profileId,
            accountId: this.state.accountId,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailID: this.state.emailId,
            phoneNumber: this.state.phoneNumber,
            amount: this.state.finalPaymentAmount,
            diffAmount: this.state.diffAmount,
            transactionId: this.state.transactionId,
            token: this.state.token,
            paymentType: paymentTypeName,
            fundingSource: this.state.fundingSource,
            billAmount: this.state.paymentAmount,
            paymentMethodId: paymentTypeId,
            cardExpiryDate: this.state.expiryDate,
            receiptNumber: receiptNumber,
            cardType: this.state.cardType

        }
        Network.executeAxios("makePaymentOrder", "POST", dataToSend, (makePaymentOrderResponse) => {
            this.setState({ isLoading: false })
            if (makePaymentOrderResponse.STATUS === "SUCCESS") {
                Swal.fire({
                    title: this.props.locales.paymentSuccessTitleInSwal,
                    text: this.props.locales.paymentCreditTextInSwal,
                    type: '',
                    timer: 2000,
                    showCancelButton: false,
                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                }).then((result) => {
                    window.location.reload();
                });
            } else {
                this.refundOfTransaction(paymentTypeName);
            }
        })
    }

    plugNpayBtnClicked() {
        this.setState({ isLoading: true });
        var dataToSend = {
            "accountId": this.state.accountId,
            "amount": this.state.finalPaymentAmount,
            "billingName": this.state.firstName + " " + this.state.lastName
        }
        Network.executeAxios("payBillWithPlugNPay", "POST", dataToSend, (Response) => {
            this.setState({ isLoading: false, plugNPayInitialResponse: Response });
            window.location.replace("./plugNPay.html?responseData=" + encodeURIComponent(JSON.stringify(this.state.plugNPayInitialResponse)));
        });
    }

    refundOfTransaction(paymentTypeName) {
        this.setState({ isLoading: false })
        Swal.fire({
            title: this.props.locales.paymentFailureTitleInSwal,
            text: this.props.locales.paymentRefundtTextInSwal,
            type: '',
            showCancelButton: false,
            confirmButtonText: 'Ok',
        }).then((result) => {
            var refundData = {
                transactionId: this.state.transactionId,
                amount: GeneralUtils.formatNumberToStandardForm(this.state.finalPaymentAmount,this.props.configurationValues)
            }
            if (paymentTypeName == "TSYS") {
                Network.executeAxios("tsysRefundPayment", "POST", refundData, (makePaymentOrderResponse) => {
                    window.location.reload();
                });
            } else if (paymentTypeName == "DWOLLA") {
                Network.executeAxios("dwollaCancelTransfer", "POST", refundData, (makePaymentOrderResponse) => {
                    window.location.reload();
                });

            } else if (paymentTypeName == "PAYPAL") {
                Network.executeAxios("paypalRefundPayment", "POST", refundData, (makePaymentOrderResponse) => {
                    window.location.reload();
                });
            }

        });
    }

    handleFinalMakePaymentResponse = (response) => {
        var dataToSend = {
            email: this.state.emailId,
            transactionId: this.state.transactionId,
            orderId: this.state.finalOrderId
        }
        Network.executeAxios("insertOrderId", "POST", dataToSend, (Response) => {
            this.setState({ isLoading: false })
            //var paymentReceiptInString = this.state.paymentReceipt.toString();
            //const finalPaymentReceipt = paymentReceiptInString.split("\n").join("<br/>");

            Swal.fire({
                title: this.props.locales.paymentSuccessTitleInSwal,
                text: this.props.locales.paymentCreditTextInSwal,
                type: '',
                timer: 2000,
                showCancelButton: false,
                confirmButtonText: this.props.locales.okButtonTextInSwal,
            }).then((result) => {
                // this.setState({
                //     paymentReceipt :finalPaymentReceipt,
                //     isAddCardBtnEnabled : false,
                //     isPaymentReceiptModalVisible:true,
                //     isLoading: true,
                //     isPaymentModalVisible : false

                // })
                window.location.reload();
            });
        });
    }
    modalCancelButtonClicked = () => {                   //credit / debit card
        var paymentDetailArray = []
        var paymentDetailObjectInsideArray = {
            payment_mode: "10",
            reference_external_id: this.state.tsysReferenceId,
            amount_paid: GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges,this.props.configurationValues)
        }
        paymentDetailArray.push(paymentDetailObjectInsideArray)
        // var paymentDetailsToSend = {
        //     upfront_payment: true,
        //     payment_received: true,
        //     amount_paid: GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges),
        //     currency_code: "USD",
        //     payment_detail: paymentDetailArray
        // }

        // var autopayValue = ""
        // if (this.state.isAutopayEnabled) {
        //     autopayValue = 1
        // } else {
        //     autopayValue = 0
        // }

        // var cardDetailsToSend = {
        //     amount: this.state.amount,
        //     token: this.state.tsysToken,
        //     expiryDate: this.state.expiryDate,
        //     cvv: this.state.cvv,
        //     lastFourDigit: this.state.lastFourDigit
        // }
        this.setState({
            isPaymentReceiptModalVisible: false,
            isLoading: true
        })

    }
    populateAllSavedCards() {
        const allSavedCardDetails = this.state.savedCardDetails.map((item, key) => {
            return (
                <div key={key} className="mt-3 d-flex" style={{ padding: 10, backgroundColor: '#ffffff', boxShadow: '0 2px 10px 0 rgba(0,0,0,0.1)', height: 80, borderRadius: 6 }}>
                    <div className="px-3 py-4" style={{ backgroundColor: 'rgba(35,31,32,0.1)', borderRadius: 6, height: 60, width: 60 }}><FaCreditCard style={{ marginTop: -12, fontSize: 30, color: '#231F20' }} /></div>
                    <div className="w-100 p-3">
                        <div className="d-flex justify-content-between">
                            <div></div>
                        </div>
                        <div className="d-flex">
                            <div style={{ fontWeight: 500, fontSize: 18, letterSpacing: 5, color: '#231F20' }}>XXXX XXXX XXXX {item.card_number}</div>
                        </div>

                    </div>
                </div>
            )
        })
        if (this.state.savedCardDetails.length > 0) {
            return (allSavedCardDetails);
        } else {
            return (<div className="mt-3"><NoDataFound content="No Saved Cards" /></div>)
        }
    }

    toggleAutopay = () => {
        this.setState(prevState => {
            return {
                isAutopayEnabled: !prevState.isAutopayEnabled
            };
        });
    };

    render() {
        return (
            <div className="animated fadeIn col-md-12 p-0 m-0">
                {this.state.skeltonScreenLoading ? SkeltonScreens.skeltonScreenForMyAccountAddServiceAddress() : null}
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {!this.state.skeltonScreenLoading ? this.componentContent() : null}
            </div>
        );
    }

    componentContent() {
        return (
            <div className="">

                <SliderModal
                    isVisible={this.state.isPaymentModalVisible}
                    uniqueModalReferenceId="paymentModal"
                    mainHeading="Payment"
                    leftPartFlexValue={1}
                    rightPartFlexValue={1}
                    isResetButtonVisible={false}
                    isSubmitButtonVisible={false}
                    cancelButtonText="Back"
                    contentPartBackgroundColor='#FFFFFF'
                    isValidationRequired={false}
                    isOnboardingPayment={true}
                    isButtonGroupRequired={true}
                    callback={this.paymentModalHandler}
                >
                    <div className="col-md-12 p-0">
                        <div className="col-md-12 pr-0">
                            <div className="col-md-12 pl-0 pr-0">
                                {this.state.billDueDate.indexOf('000') < 0 ?
                                    <div className="col-md-12 p-0 py-3" style={{ backgroundColor: '#F4F8F9' }}>
                                        <div className="col-md-12 row m-0 py-2">
                                            <div className="col-md-6 row m-0">
                                                <span className="paymentTopLebel">Account Number :</span>
                                                <span className="paymentTopValues">{this.state.accountId}</span>
                                            </div>
                                            <div className="col-md-6 row m-0">
                                                <span className="paymentTopLebel">Due Date :</span>
                                                <span className="paymentTopValues">{this.state.billDueDate}</span>
                                            </div>
                                            {/* <div className="col-md-6 row m-0 p-0">
                                        <span className="paymentTopLebel">Bill Cycle :</span>
                                        {this.state.billPeriod != "" && this.state.billPeriod != null && this.state.billPeriod != undefined ?
                                            <span className="paymentTopValues">{this.state.billPeriod}</span>
                                        :
                                            <span className="paymentTopValues">{this.state.billStartDate}-{this.state.billEndDate}</span>
                                        }
                                    </div> */}
                                        </div>
                                        <div className="col-md-12 row m-0 pb-2">
                                            <div className="col-md-6 row m-0">
                                                <span className="paymentTopLebel">Total Due :</span>
                                                <span className="paymentTopValues" style={{ color: '#E31937' }}>{this.state.paymentAmount}</span>
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                                <div className="col-md-12 pl-0 pt-3 px-3" >
                                    <div className="col-md-6 paymentTopValues mb-2">Pay Now</div>
                                    <div className="col-md-6 form-group">
                                        <input type="text" className="form-control formGroup_value "
                                            value={this.state.finalPaymentAmount} style={{ boxShadow: 'unset', outline: 'none' }}
                                            onChange={(event) => this.handleInputValueChange("finalPaymentAmount", event.target.value)} />
                                    </div>
                                </div>
                                {parseFloat(this.state.diffAmount) > 0 ?
                                    <div className="col-md-12 px-4 ml-2" style={{ fontSize: 14, color: '#58595B' }}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(this.state.diffAmount,this.props.configurationValues)} {this.props.locales.advancePaymentLabelInPaymentSlider}</div>
                                    : null}

                                {/* <div className="tsysContainer col-md-8 mt-5" style={parseFloat(this.state.paypalAmount) > 0 ? { height: 76, visibility: 'visible' } : { height: 76, visibility: 'hidden' }}>
                                    <iframe title="" src={"./PayPal.html?clientId=" + this.state.paypalClientId + "&amount=" + this.state.paypalAmount} style={{ width: '100%', border: 'none' }} className={this.state.isPaypalButtonRendered ? "payPalButtonRendered" : "paypalBtnPreRendered"} frameBorder="0"> </iframe>
                                </div> */}
                                {parseFloat(this.state.paypalAmount) > 0 ?
                                    <div className="col-md-12 px-3 pt-4 pl-4 ml-2">
                                        <Button className="pluNPayBtn animated fadeIn" style={{ width: 300, height: 42 }} onClick={() => { this.plugNpayBtnClicked() }}>
                                            Pay&nbsp;<FaArrowRight />
                                        </Button>
                                    </div>
                                    : null}

                            </div>
                        </div>
                    </div>


                </SliderModal>

                <Modal isOpen={this.state.isPaymentReceiptModalVisible} size="md" centered>
                    <ModalBody style={{ height: '100%' }}>
                        <button type="button" className="close" style={{ position: "absolute", top: 3, right: 10, cursor: 'pointer', zIndex: 1000, color: '#E21736', outline: 'none' }} onClick={() => { this.modalCancelButtonClicked() }}>
                            <span aria-hidden="false" style={{ fontSize: 30 }}>&times;</span>
                        </button>
                        <div style={{ zIndex: 1090 }}>
                            <div className=" text-center" style={{ marginBottom: 14, borderBottom: "1px solid #eaedf0", fontSize: 25, padding: "25px 25px 18px 25px", marginLeft: 32, marginRight: 32, fontWeight: 'bold', color: '#E21736' }}>Receipt</div>
                            <div style={{ width: '100%', height: '100%', padding: 20 }}>
                                <div style={{ textAlign: 'center', fontWeight: 500, wordSpacing: 6 }} dangerouslySetInnerHTML={{ __html: this.state.paymentReceipt }} />
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isDwollaTandCModalOpen} size="lg" centered>
                    <ModalBody style={{ height: '100%' }}>
                        <div style={{ zIndex: 1090 }}>
                            <div style={{ width: '100%', height: '100%', padding: 20 }}>
                                <div style={{ textAlign: 'justify', fontSize: 16, color: '#231F20', fontWeight: 500 }}>Account Creation Terms and Conditions</div>
                            </div>
                            <div style={{ width: '100%', height: '100%', padding: 20 }}>
                                <div style={{ textAlign: 'justify', fontSize: 12, color: '#58595B' }}>
                                    Please carefully read through the following information as it defines the legal relationship between you and Hargray as of the date of your initial service order. New Customers who do not agree to these terms may, within 5 days of the date you placed your order, cancel your order by contacting Hargray.
                                    For purposes of this General Residential Terms & Conditions (the “Agreement”), the “Customer” refers to you, the Hargray subscriber, and “Hargray” refers to Hargray Communications Group, Inc. and any of its affiliates and third-party partners.
                                    At the time of your order for Services, whether by phone, online or at a retail store, you may have been provided a promotional offer (the “Promotion”). The terms of such Promotion shall, along with this Agreement, collectively provide the entire Terms and Conditions with respect to your residential services from Hargray. Unless otherwise expressly set forth herein, in the event that the terms and conditions of the Promotion (or any other agreement entered into between you and Hargray) differ from that of this Agreement, the terms and conditions of this Agreement shall govern the relationship between you and Hargray and supersede any other terms, conditions or contracts entered into by you with respect to such Services.
                                </div>
                            </div>
                            <div className="text-center" style={{ width: '100%', height: '100%', padding: 20 }}>
                                <button style={{ boxShadow: 'unset', outline: 'none', width: 140, height: 38, fontWeight: 500, border: '1px solid #E21736', borderRadius: 4, backgroundColor: '#ffffff', color: '#E21736' }} onClick={() => { this.accountCreationTandCCloseBtnClicked() }}>Close</button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.showDwollaTermsAndConditions} size="lg" centered>
                    <ModalBody style={{ height: '100%' }}>
                        <div style={{ zIndex: 1090 }}>
                            <div style={{ width: '100%', height: '100%', padding: 20 }}>
                                <div style={{ textAlign: 'justify', fontSize: 16, color: '#231F20', fontWeight: 500 }}>Add Funding Source Terms and Conditions</div>
                            </div>
                            <div style={{ width: '100%', height: '100%', padding: 20 }}>
                                <div style={{ textAlign: 'justify', fontSize: 12, color: '#58595B' }}>
                                    Please carefully read through the following information as it defines the legal relationship between you and Hargray as of the date of your initial service order. New Customers who do not agree to these terms may, within 5 days of the date you placed your order, cancel your order by contacting Hargray.
                                    For purposes of this General Residential Terms & Conditions (the “Agreement”), the “Customer” refers to you, the Hargray subscriber, and “Hargray” refers to Hargray Communications Group, Inc. and any of its affiliates and third-party partners.
                                    At the time of your order for Services, whether by phone, online or at a retail store, you may have been provided a promotional offer (the “Promotion”). The terms of such Promotion shall, along with this Agreement, collectively provide the entire Terms and Conditions with respect to your residential services from Hargray. Unless otherwise expressly set forth herein, in the event that the terms and conditions of the Promotion (or any other agreement entered into between you and Hargray) differ from that of this Agreement, the terms and conditions of this Agreement shall govern the relationship between you and Hargray and supersede any other terms, conditions or contracts entered into by you with respect to such Services.
                                </div>
                            </div>
                            <div className="d-flex w-50 mx-auto">
                                <div className="text-center" style={{ width: '100%', height: '100%', padding: 20 }}>
                                    <button style={{ boxShadow: 'unset', outline: 'none', width: 140, height: 38, border: '1px solid #E21736', borderRadius: 4, backgroundColor: '#ffffff', color: '#E21736' }} onClick={() => { this.addFSTandCDeclineBtnClicked() }}>Decline</button>
                                </div>
                                <div className="text-center" style={{ width: '100%', height: '100%', padding: 20 }}>
                                    <button style={{ boxShadow: 'unset', outline: 'none', width: 140, height: 38, fontWeight: 500, border: '1px solid #E21736', borderRadius: 4, backgroundColor: '#E21736', color: '#ffffff' }} onClick={() => { this.addFSTandCAcceptBtnClicked() }}>Accept</button>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

const PaymentComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentComponent)

export default PaymentComponentContainer;